import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    logout: 'Logout',
    welcome: 'Welcome',
    
    // Navigation
    dashboard: 'Dashboard',
    products: 'Products',
    materials: 'Raw Materials',
    inventory: 'Inventory',
    suppliers: 'Suppliers',
    purchases: 'Purchases',
    customers: 'Customers',
    sales: 'Sales',
    dailyOrders: 'Daily Orders',
    expenses: 'Expenses',
    balanceSheet: 'Balance Sheet',
    employees: 'Employees',
    reports: 'Reports',
    settings: 'Settings',
    users: 'Users',
    activityLogs: 'Activity Logs',
    
    // Dashboard
    todaySales: "Today's Sales",
    monthSales: 'Monthly Sales',
    monthExpenses: 'Monthly Expenses',
    totalDebt: 'Total Debt',
    netProfit: 'Net Profit',
    lowStock: 'Low Stock',
    recentSales: 'Recent Sales',
    quickStats: 'Quick Stats',
    
    // Actions
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    print: 'Print',
    
    // Products
    productName: 'Product Name',
    category: 'Category',
    price: 'Price',
    cost: 'Cost',
    stock: 'Stock',
    unit: 'Unit',
    minStock: 'Min Stock',
    addProduct: 'Add Product',
    
    // Suppliers
    supplierName: 'Supplier Name',
    contactPerson: 'Contact Person',
    phone: 'Phone',
    address: 'Address',
    addSupplier: 'Add Supplier',
    
    // Purchases
    purchaseDate: 'Purchase Date',
    supplier: 'Supplier',
    total: 'Total',
    paymentStatus: 'Payment Status',
    addPurchase: 'Add Purchase',
    pending: 'Pending',
    paid: 'Paid',
    partial: 'Partial',
    
    // Customers
    customerName: 'Customer Name',
    debt: 'Debt',
    addCustomer: 'Add Customer',
    recordPayment: 'Record Payment',
    
    // Sales
    invoice: 'Invoice',
    newSale: 'New Sale',
    subtotal: 'Subtotal',
    discount: 'Discount',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    walkInCustomer: 'Walk-in Customer',
    
    // Expenses
    expenseCategory: 'Category',
    description: 'Description',
    amount: 'Amount',
    date: 'Date',
    addExpense: 'Add Expense',
    
    // Employees
    employeeName: 'Employee Name',
    position: 'Position',
    salary: 'Salary',
    hireDate: 'Hire Date',
    addEmployee: 'Add Employee',
    paySalary: 'Pay Salary',
    
    // Reports
    dailyReport: 'Daily Report',
    weeklyReport: 'Weekly Report',
    monthlyReport: 'Monthly Report',
    yearlyReport: 'Yearly Report',
    salesReport: 'Sales Report',
    expensesReport: 'Expenses Report',
    profitReport: 'Profit Report',
    
    // Common
    noData: 'No data available',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Operation successful',
    confirm: 'Are you sure?',
    currency: '£',
  },
  ar: {
    // Auth
    login: 'تسجيل الدخول',
    register: 'تسجيل جديد',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    logout: 'تسجيل الخروج',
    welcome: 'مرحباً',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    products: 'المنتجات',
    materials: 'المواد الخام',
    inventory: 'المخزون',
    suppliers: 'الموردين',
    purchases: 'المشتريات',
    customers: 'العملاء',
    sales: 'المبيعات',
    dailyOrders: 'طلبيات اليوم',
    expenses: 'المصروفات',
    balanceSheet: 'كشف الحساب',
    employees: 'الموظفين',
    reports: 'التقارير',
    settings: 'الإعدادات',
    users: 'المستخدمين',
    activityLogs: 'سجل النشاطات',
    
    // Dashboard
    todaySales: 'مبيعات اليوم',
    monthSales: 'مبيعات الشهر',
    monthExpenses: 'مصروفات الشهر',
    totalDebt: 'إجمالي الديون',
    netProfit: 'صافي الربح',
    lowStock: 'مخزون منخفض',
    recentSales: 'آخر المبيعات',
    quickStats: 'إحصائيات سريعة',
    
    // Actions
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'فلتر',
    export: 'تصدير',
    print: 'طباعة',
    
    // Products
    productName: 'اسم المنتج',
    category: 'الفئة',
    price: 'السعر',
    cost: 'التكلفة',
    stock: 'المخزون',
    unit: 'الوحدة',
    minStock: 'الحد الأدنى',
    addProduct: 'إضافة منتج',
    
    // Suppliers
    supplierName: 'اسم المورد',
    contactPerson: 'جهة الاتصال',
    phone: 'الهاتف',
    address: 'العنوان',
    addSupplier: 'إضافة مورد',
    
    // Purchases
    purchaseDate: 'تاريخ الشراء',
    supplier: 'المورد',
    total: 'الإجمالي',
    paymentStatus: 'حالة الدفع',
    addPurchase: 'إضافة مشتريات',
    pending: 'معلق',
    paid: 'مدفوع',
    partial: 'جزئي',
    
    // Customers
    customerName: 'اسم العميل',
    debt: 'الدين',
    addCustomer: 'إضافة عميل',
    recordPayment: 'تسجيل دفعة',
    
    // Sales
    invoice: 'فاتورة',
    newSale: 'بيع جديد',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    quantity: 'الكمية',
    unitPrice: 'سعر الوحدة',
    walkInCustomer: 'عميل عابر',
    
    // Expenses
    expenseCategory: 'الفئة',
    description: 'الوصف',
    amount: 'المبلغ',
    date: 'التاريخ',
    addExpense: 'إضافة مصروف',
    
    // Employees
    employeeName: 'اسم الموظف',
    position: 'المنصب',
    salary: 'الراتب',
    hireDate: 'تاريخ التعيين',
    addEmployee: 'إضافة موظف',
    paySalary: 'دفع الراتب',
    
    // Reports
    dailyReport: 'تقرير يومي',
    weeklyReport: 'تقرير أسبوعي',
    monthlyReport: 'تقرير شهري',
    yearlyReport: 'تقرير سنوي',
    salesReport: 'تقرير المبيعات',
    expensesReport: 'تقرير المصروفات',
    profitReport: 'تقرير الأرباح',
    
    // Common
    noData: 'لا توجد بيانات',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    success: 'تمت العملية بنجاح',
    confirm: 'هل أنت متأكد؟',
    currency: '£',
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'ar');
  const [direction, setDirection] = useState(localStorage.getItem('language') === 'en' ? 'ltr' : 'rtl');

  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
    localStorage.setItem('language', language);
  }, [language, direction]);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ar' : 'en';
    setLanguage(newLang);
    setDirection(newLang === 'ar' ? 'rtl' : 'ltr');
  };

  const t = (key) => translations[language][key] || key;

  const value = {
    language,
    direction,
    toggleLanguage,
    t,
    isRTL: direction === 'rtl',
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
